import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH PROMOTION_IN_PRODUCTS_FORM DATA ********************
export const fetchPromotionInForm = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROMOTION_IN_PRODUCTS_FORM_LOADING,
			payload: true
		});

		const url = `promotions/${id}/algorithm/in`;
		const { data } = await services.get(url);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROMOTION_IN_PRODUCTS_FORM_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROMOTION_IN_PRODUCTS_FORM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
